
import React, { useEffect, useRef, useState } from "react";
import { convertCase } from "../../../SharedFiles/Helper/utils";
import QrContainer from "../../../SharedFiles/QRCode/qrReader";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import CommonSearch from "../../../SharedFiles/CommonSearch/CommonSearch";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { GetTestITData } from "../../../APIServices/ProductionService/ITServices/ITThunk";
import { useTranslation } from 'react-i18next';
const ITInput = ({
  inputfieldLabel,
  inputValues,
  modelfields,
  handleSelectSuggestion,
  openManual,
  setOpenManual,
  scanmodalVisible,
  handleSubmit,
  formData,
  setFormData,
  setInputValues,
  setErrorMessage,
  errorMessage,
  handleScanModeClose,
  editMode,
  callInProgress,
  handleQrScan,
  disabledFields,
}) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const { t } = useTranslation();
  const { TestITData, GetToWarehouse } = useSelector(
    (state) => state.InvTransfer || {}
  );
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [filteredWhsData, setFilteredWhsData] = useState({});
  const dispatch = useDispatch();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // If the click is outside the dropdown, reset visibility
        setDropdownVisible(false);
      }
    };
    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);
    // Cleanup the event listener when component is unmounted
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleWhsClick = (header) => {
    setDropdownVisible((prevState) => ({
      ...prevState,
      [header]: true,
    }));
    setFilteredWhsData(GetToWarehouse);
  };
  const handlewhschange = (e, header) => {
    setErrorMessage({})
    const value = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      [header]: value,
    }));
    if (header === "toWhs") {
      const filteredData =
        GetToWarehouse &&
        GetToWarehouse?.filter(
          (item) => item.whs_Code.toLowerCase().includes(value.toLowerCase()) // case-insensitive search
        );
      setDropdownVisible((prevState) => ({
        ...prevState,
        [header]: true,
      }));
      setFilteredWhsData(filteredData);
    }
  };
  const handleSelectwhs = (item, header) => {
    setErrorMessage({})
    setDropdownVisible((prevState) => ({
      ...prevState,
      [header]: false,
    }));
    setFormData((prevState) => ({
      ...prevState,
      toWhs: item.whs_Code,
    }));
  };
  const handleFormSubmit = () => {
    if (!formData.toWhs) {
      toast.error(t('Select a warehouse'));
      return;
    }
    handleSubmit(formData);
  };

  const handleOpenModal = () => {
    dispatch(
      GetTestITData({
        search_term: "",
        prev_value: "",
        search_field: "ItemCode",
      })
    );
    setOpenManual(!openManual);
  };
  
  return (
    <Dialog open={scanmodalVisible}>
      <DialogTitle className="Modal-heading">
        {t('Item Details')}
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleScanModeClose}
          style={{ position: "absolute", right: "18px", top: "10px" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="custom-dialog-content">
        <div className="column">
          {openManual ? (
            <>
              <CommonSearch
                inputFields={inputfieldLabel}
                values={inputValues}
                data={TestITData ? TestITData : []}
                setValues={setInputValues}
                disabledFields={disabledFields}
                handleDropdownClick={handleSelectSuggestion}
                callName="ItInput"
              />
              {callInProgress && callInProgress.ItemDataByBatch && (
                <div className="d-grid">
                  {modelfields &&
                    modelfields.map((header, index) =>
                      header === "toWhs" ? (
                        <div key={index}>
                          <TextField
                            label={t(convertCase(header))}
                            variant="outlined"
                            className="form-control custom-modal-textfield fieldbottom"
                            style={{ marginBottom: "10px" }}
                            value={formData[header] || ""}
                            onClick={() => handleWhsClick(header)}
                            onChange={(e) => handlewhschange(e, header)}
                            error={errorMessage && errorMessage[header]}
                            helperText={errorMessage && errorMessage[header]}
                          />
                          {dropdownVisible[header] && header === "toWhs" && (
                            <ul
                            ref={dropdownRef}
                              className="list-group position-absolute"
                              style={{
                                maxHeight: "200px",
                                overflowY: "auto",
                                zIndex: 10,
                                width: '285px'
                              }}
                            >
                              {filteredWhsData?.length > 0 ? (
                                filteredWhsData?.filter((whs) => whs.whs_Code !== formData.from_Whs).map((item, index) => (
                                  <li
                                    key={index}
                                    className="list-group-item list-group-item-action"
                                    onClick={() =>
                                      handleSelectwhs(item, header)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {item.whs_Code}
                                  </li>
                                ))
                              ) : (
                                <li className="list-group-item">
                                  No results found
                                </li>
                              )}
                            </ul>
                          )}
                        </div>
                      ) : (
                        <div key={index}>
                          <TextField
                            label={t(convertCase(header))}
                            variant="outlined"
                            className="form-control custom-modal-textfield"
                            style={{ marginBottom: "10px" }}
                            value={formData[header] || ""}
                            disabled={
                              disabledFields && disabledFields.includes(header)
                            }
                          />
                        </div>
                      )
                    )}
                </div>
              )}
            </>
          ) : (
            <QrContainer openManual={openManual} elementId="Inventory_Transfer" onScan={handleQrScan} />
          )}
        </div>
      </DialogContent>

      <DialogActions className="custom-dialog-actions">
        <Button onClick={handleOpenModal}>
          {openManual ? "Scanner" : "Manual"}
        </Button>
        <Button className="Modal-cancel" onClick={handleScanModeClose}>
          Cancel
        </Button>

        {formData && (
          <Button onClick={handleFormSubmit} className="Modal-submit">
            {editMode ? "Update" : "Add"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ITInput;
